import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import SlateEditor from './SlateDescriptionCore';
import messages from '../../../../../../messages';

const DescriptionBlockSchema = (props) => ({
  title: 'Beschreibung',
  fieldsets: [
    {
      id: 'default',
      title: 'Einstellungen',
      fields: ['blockWidth'],
    },
  ],
  properties: {
    blockWidth: {
      title: props.intl.formatMessage(messages.blockWidthCustom),
      widget: 'align',
      actions: ['narrow', 'normal', 'wide', 'full'],
      default: 'normal',
    },
  },
  required: [],
});

const Edit = (props) => {
  const { selected, block, data, onChangeBlock } = props;
  const schema = DescriptionBlockSchema(props);

  const handleChange = (field, value) => {
    if (field === 'blockWidth') {
      onChangeBlock(block, {
        ...data,
        styles: {
          ...(data.styles || {}),
          blockWidth: value,
        },
      });
    }
  };

  return (
    <>
      <SlateEditor {...props} />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          formData={{
            ...data,
            blockWidth: data?.styles?.blockWidth,
          }}
          block={block}
          onChangeField={handleChange}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
